var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 45,
    viewBox: "0 0 53 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1144_38366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2063 30.0414C29.9985 28.1532 27.758 27.0094 25.5774 28.8948L24.2753 30.0343C23.3226 30.8615 21.5513 34.7264 14.7029 26.8482C7.85582 18.98 11.9304 17.755 12.8845 16.9349L14.1937 15.794C16.3629 13.9043 15.5443 11.5255 13.9798 9.07672L13.0357 7.5935C11.464 5.15047 9.75263 3.54603 7.57772 5.43286L6.40256 6.4597C5.44132 7.15995 2.75441 9.43612 2.10265 13.7603C1.31826 18.9487 3.79266 24.8901 9.46169 31.4091C15.1236 37.931 20.6671 41.2069 25.9183 41.1499C30.2824 41.1028 32.9179 38.761 33.7422 37.9096L34.9217 36.8813C37.0909 34.9959 35.7432 33.0763 33.534 31.1838L32.2063 30.0414Z",
    fill: "#BDC3C6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.8828 0.951172V44.8061",
    stroke: "#D6DCDF",
    strokeWidth: 1.82729
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1144_38366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.5456,
    height: 36.5456,
    fill: "white",
    transform: "translate(0.71875 4.60547)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/mobile-icon.0933cf66b80071afeeee7f535c944905.svg";
export { ForwardRef as ReactComponent };